import React from 'react';

const BUTTON_CLASS_BY_TONE = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  outline: 'btn-outline',
};

const ContextualHelpPanel = ({
  title,
  summary,
  purpose,
  steps = [],
  prerequisites = [],
  actions = [],
  note,
  variant = 'info',
  collapsed = false,
  onDismiss,
  onExpand,
  dismissLabel = 'Hide tips',
  expandLabel = 'Show tips',
  prerequisitesTitle = 'Before you continue',
  stepsTitle = 'Suggested next steps',
}) => {
  if (collapsed) {
    return (
      <section className={`df-help-panel df-help-panel--${variant} df-help-panel--collapsed`}>
        <div className="df-help-panel-header">
          <div>
            <h3 className="df-help-panel-title">Tips hidden for this tab</h3>
            <p className="df-help-panel-summary">
              Show tips again whenever you want the workflow guidance back.
            </p>
          </div>
          {onExpand && (
            <button type="button" className="btn btn-outline btn-sm" onClick={onExpand}>
              {expandLabel}
            </button>
          )}
        </div>
      </section>
    );
  }

  return (
    <section className={`df-help-panel df-help-panel--${variant}`}>
      <div className="df-help-panel-header">
        <div>
          <h3 className="df-help-panel-title">{title}</h3>
          {summary && <p className="df-help-panel-summary">{summary}</p>}
        </div>
        {onDismiss && (
          <button type="button" className="btn btn-outline btn-sm" onClick={onDismiss}>
            {dismissLabel}
          </button>
        )}
      </div>

      {purpose && (
        <p className="df-help-panel-purpose">
          <strong>This tab is for:</strong> {purpose}
        </p>
      )}

      {prerequisites.length > 0 && (
        <div className="df-help-panel-section">
          <div className="df-help-panel-section-title">{prerequisitesTitle}</div>
          <div className="df-help-checklist">
            {prerequisites.map((item) => (
              <div
                key={item.id}
                className={`df-help-checklist-item ${item.complete ? 'is-complete' : 'is-missing'}`}
              >
                <div className="df-help-checklist-status">{item.complete ? 'Ready' : 'Missing'}</div>
                <div>
                  <div className="df-help-checklist-label">{item.label}</div>
                  {item.description && (
                    <div className="df-help-checklist-description">{item.description}</div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {steps.length > 0 && (
        <div className="df-help-panel-section">
          <div className="df-help-panel-section-title">{stepsTitle}</div>
          <ol className="df-help-step-list">
            {steps.map((step) => (
              <li key={step} className="df-help-step-item">
                {step}
              </li>
            ))}
          </ol>
        </div>
      )}

      {note && <div className="df-help-panel-note">{note}</div>}

      {actions.length > 0 && (
        <div className="df-help-panel-actions">
          {actions.map((action) => (
            <button
              key={action.id || action.label}
              type="button"
              className={`btn ${BUTTON_CLASS_BY_TONE[action.tone] || 'btn-secondary'}`}
              onClick={action.onClick}
              disabled={action.disabled}
            >
              {action.label}
            </button>
          ))}
        </div>
      )}
    </section>
  );
};

export default ContextualHelpPanel;
